// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import PreLaminationView from './view_inspection_forms/PreLaminationView';
// import PostLaminationView from './view_inspection_forms/PostLaminationView';
// import BillOfMaterial from './view_inspection_forms/BillOfMaterial';
// import DailyVolumeF4 from './view_inspection_forms/DailyVolumeF4';
// import StringerMain from './view_inspection_forms/StringerMain';
// import LaminationMachine from './view_inspection_forms/LaminationMachine';
// import CalibrationVerification from './view_inspection_forms/CalibrationVerification';
// import FlashTestWitness from './view_inspection_forms/FlashTestWitness';
// import PrimaryModuleCalibration from './view_inspection_forms/PrimaryModuleCalibration';
// import FrameSealantWeightVerification from './view_inspection_forms/FrameSealantWeightVerification';
// import JunctionBoxSealantWeightVerification from './view_inspection_forms/JunctionBoxSealantWeight';
// import JunctionBoxPottingMaterial from './view_inspection_forms/JunctionBoxPotting';
// import ModuleDimensionCheck from './view_inspection_forms/ModuleDimensionCheck';
// import RecordRejectedModule from './view_inspection_forms/RecordRejectedModule';
// import RFIDReadability from './view_inspection_forms/RFID';
// import MachineBreakdownHistory from './view_inspection_forms/MachineBreakdown';
// import RootCauseAnalysis from './view_inspection_forms/RootCauseAnalysis';

// const ViewInspection = () => {
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [expandedForm, setExpandedForm] = useState(null);
//   const [suppliers, setSuppliers] = useState([]);
//   const [selectedDate, setSelectedDate] = useState(sessionStorage.getItem('inspectionDate') || '');
//   const [selectedSupplier, setSelectedSupplier] = useState(sessionStorage.getItem('inspectionSupplier') || '');
//   const [selectedShift, setSelectedShift] = useState(sessionStorage.getItem('inspectionShift') || '');
//   const [shiftOptions, setShiftOptions] = useState([]);
//   const [showToast, setShowToast] = useState(false);

//   // Fetch supplier names and shift options using POST
//   useEffect(() => {
//     const fetchSuppliers = async () => {
//       try {
//         const selectedProject = localStorage.getItem('selectedProject');
//         const response = await axios.post('https://redoms-backend-dev.m-devsecops.com/get_supplier_names', {
//           projectId: selectedProject,
//         });
//         setSuppliers(response.data);
//         const supplier = response.data.find(s => s.name === selectedSupplier) || response.data[0];
//         if (supplier) {
//           setShiftOptions(supplier.shift === 'MorningAfternoonNight' 
//             ? ['Morning', 'Afternoon', 'Night'] 
//             : ['Day', 'Night']);
//         }
//       } catch (err) {
//         console.error('Error fetching supplier data:', err);
//         setError('Failed to load supplier data.');
//         setShowToast(true);
//       }
//     };
//     fetchSuppliers();
//   }, []);

//   // Update shift options when supplier changes
//   useEffect(() => {
//     const supplier = suppliers.find(s => s.name === selectedSupplier);
//     if (supplier) {
//       setShiftOptions(supplier.shift === 'MorningAfternoonNight' 
//         ? ['Morning', 'Afternoon', 'Night'] 
//         : ['Day', 'Night']);
//       setSelectedShift('');
//     }
//   }, [selectedSupplier, suppliers]);

//   // Fetch inspection data
//   useEffect(() => {
//     const fetchInspectionData = async () => {
//       const date = sessionStorage.getItem('inspectionDate');
//       const shift = sessionStorage.getItem('inspectionShift');
//       const supplier = sessionStorage.getItem('inspectionSupplier');
//       const projectId = localStorage.getItem('selectedProject');

//       if (!date || !shift || !supplier || !projectId) {
//         setError('Missing required inspection parameters.');
//         setShowToast(true);
//         setLoading(false);
//         return;
//       }

//       try {
//         const response = await axios.post('https://redoms-backend-dev.m-devsecops.com/get_inspection', {
//           inspectionDate: date,
//           inspectionShift: shift,
//           inspectionSupplier: supplier,
//           projectId,
//         });
//         sessionStorage.setItem('inspectionData', JSON.stringify(response.data[0] || {}));
//         setLoading(false);
//       } catch (err) {
//         console.error('Error fetching inspection data:', err);
//         setError('Failed to load inspection data. Please try again.');
//         setShowToast(true);
//         setLoading(false);
//       }
//     };

//     fetchInspectionData();
//   }, []);

//   // Auto-dismiss toast after 5 seconds
//   useEffect(() => {
//     if (showToast) {
//       const timer = setTimeout(() => setShowToast(false), 5000);
//       return () => clearTimeout(timer);
//     }
//   }, [showToast]);

//   const toggleForm = (formKey) => {
//     setExpandedForm(expandedForm === formKey ? null : formKey);
//   };

//   const handleSearch = () => {
//     if (selectedDate && selectedSupplier && selectedShift) {
//       sessionStorage.setItem('inspectionDate', selectedDate);
//       sessionStorage.setItem('inspectionSupplier', selectedSupplier);
//       sessionStorage.setItem('inspectionShift', selectedShift);
//       window.location.reload();
//     } else {
//       setError('Please select date, supplier, and shift.');
//       setShowToast(true);
//     }
//   };

//   const GenericFormView = () => {
//     const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
//     const formKey = 'stringerMainFormData';
//     const data = inspectionData[formKey];
//     if (!data) return <p className="text-gray-500 text-center">No data available</p>;
//     return (
//       <pre className="bg-gray-50 p-4 rounded-lg text-sm overflow-auto max-h-96 shadow-inner">
//         {JSON.stringify(data, null, 2)}
//       </pre>
//     );
//   };

//   const formComponents = {
//     PreLaminationFormData: PreLaminationView,
//     PostLaminationFormData: PostLaminationView,
//     BillOfMaterials: BillOfMaterial,
//     DailyVolumeFormData: DailyVolumeF4,
//     StringerFormData: StringerMain,
//     PeelStrengthFormData: GenericFormView,
//     CellToRibbonPeelStrengthFormData: GenericFormView,
//     LaminationMachineFormData: LaminationMachine,
//     CalibrationVerificationFormData: CalibrationVerification,
//     FlashTestWitnessFormData: FlashTestWitness,
//     PrimaryModuleCalibrationFormData: PrimaryModuleCalibration,
//     FrameSealantWeightFormData: FrameSealantWeightVerification,
//     JunctionBoxSealantFormData: JunctionBoxSealantWeightVerification,
//     JunctionBoxPottingFormData: JunctionBoxPottingMaterial,
//     ModuleDimensionCheckFormData: ModuleDimensionCheck,
//     RecordRejectedModuleFormData: RecordRejectedModule,
//     RFIDReadabilityFormData: RFIDReadability,
//     MachineBreakdownFormData: MachineBreakdownHistory,
//     RootCauseAnalysis: RootCauseAnalysis,
//   };

//   const formNames = Object.keys(formComponents);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-gray-100 to-gray-200">
//         <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-600"></div>
//       </div>
//     );
//   }

//   const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-gray-100 to-gray-200 py-4 px-4 sm:px-6 lg:px-8">
//       {/* Toast Notification */}
//       {showToast && (
//         <div className="fixed top-4 right-4 z-50 animate-slide-in">
//           <div className="bg-red-500 text-white px-4 py-3 rounded-lg shadow-lg flex items-center">
//             <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//             <span>{error}</span>
//             <button onClick={() => setShowToast(false)} className="ml-4 text-white hover:text-gray-200">
//               <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
//               </svg>
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <h1 className="text-4xl font-extrabold text-gray-900 text-center mb-4">
//           Inspection Dashboard
//         </h1>
//         {/* <p className="text-lg text-gray-600 text-center mb-8">
//           Date: {sessionStorage.getItem('inspectionDate') || 'N/A'} | Shift: {sessionStorage.getItem('inspectionShift') || 'N/A'} | 
//           Supplier: {sessionStorage.getItem('inspectionSupplier') || 'N/A'} | Inspector: {inspectionData.inspectorName || 'N/A'} | 
//           Status: <span className={`font-semibold ${inspectionData.status === 'Completed' ? 'text-green-600' : 'text-yellow-600'}`}>
//             {inspectionData.status || 'N/A'}
//           </span>
//         </p> */}

//         {/* Search Section */}
//         <div className="bg-white rounded-xl shadow-2xl p-8 mb-10">
//           <h2 className="text-2xl font-semibold text-gray-800 mb-6">Search Inspection Data</h2>
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Date</label>
//               <input
//                 type="date"
//                 value={selectedDate}
//                 onChange={(e) => setSelectedDate(e.target.value)}
//                 className="w-full p-3 border border-gray-200 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
//                 aria-label="Inspection Date"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Supplier</label>
//               <select
//                 value={selectedSupplier}
//                 onChange={(e) => setSelectedSupplier(e.target.value)}
//                 className="w-full p-3 border border-gray-200 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
//                 aria-label="Supplier"
//               >
//                 <option value="">Select Supplier</option>
//                 {suppliers.map((supplier) => (
//                   <option key={supplier.name} value={supplier.name}>
//                     {supplier.name}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">Shift</label>
//               <select
//                 value={selectedShift}
//                 onChange={(e) => setSelectedShift(e.target.value)}
//                 className="w-full p-3 border border-gray-200 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
//                 aria-label="Shift"
//               >
//                 <option value="">Select Shift</option>
//                 {shiftOptions.map((shift) => (
//                   <option key={shift} value={shift}>
//                     {shift}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="flex items-end">
//               <button
//                 onClick={handleSearch}
//                 className="w-full bg-indigo-600 text-white p-3 rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition duration-200 relative overflow-hidden ripple"
//               >
//                 <span className="relative z-10">Search</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Inspection Forms */}
//         <div className="space-y-6">
//           {formNames.map((formKey) => {
//             const FormComponent = formComponents[formKey];
//             return (
//               <div
//                 key={formKey}
//                 className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl"
//               >
//                 <button
//                   onClick={() => toggleForm(formKey)}
//                   className="w-full flex justify-between items-center p-6 bg-gradient-to-r from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 focus:outline-none transition duration-200"
//                   aria-expanded={expandedForm === formKey}
//                   aria-controls={`form-${formKey}`}
//                 >
//                   <span className="text-xl font-semibold text-gray-800">
//                     {formKey.replace(/([A-Z])/g, ' $1').trim()}
//                   </span>
//                   <span className="text-gray-600 text-2xl transform transition-transform duration-200">
//                     {expandedForm === formKey ? '▲' : '▼'}
//                   </span>
//                 </button>
//                 {expandedForm === formKey && (
//                   <div id={`form-${formKey}`} className="p-8 bg-gray-50 animate-fade-in">
//                     <FormComponent />
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* Custom CSS for Ripple Effect and Animations */}
//       <style jsx>{`
//         .ripple {
//           position: relative;
//           overflow: hidden;
//         }
//         .ripple::after {
//           content: '';
//           position: absolute;
//           background: rgba(255, 255, 255, 0.3);
//           border-radius: 50%;
//           transform: scale(0);
//           animation: ripple 0.6s linear;
//           top: 50%;
//           left: 50%;
//           width: 100px;
//           height: 100px;
//           margin: -50px 0 0 -50px;
//         }
//         @keyframes ripple {
//           to {
//             transform: scale(4);
//             opacity: 0;
//           }
//         }
//         .animate-slide-in {
//           animation: slideIn 0.3s ease-out;
//         }
//         @keyframes slideIn {
//           from {
//             opacity: 0;
//             transform: translateY(-10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-fade-in {
//           animation: fadeIn 0.3s ease-out;
//         }
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//           }
//           to {
//             opacity: 1;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default ViewInspection;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PreLaminationView from './view_inspection_forms/PreLaminationView';
import PostLaminationView from './view_inspection_forms/PostLaminationView';
import BillOfMaterial from './view_inspection_forms/BillOfMaterial';
import DailyVolumeF4 from './view_inspection_forms/DailyVolumeF4';
import StringerMain from './view_inspection_forms/StringerMain';
import LaminationMachine from './view_inspection_forms/LaminationMachine';
import CalibrationVerification from './view_inspection_forms/CalibrationVerification';
import FlashTestWitness from './view_inspection_forms/FlashTestWitness';
import PrimaryModuleCalibration from './view_inspection_forms/PrimaryModuleCalibration';
import FrameSealantWeightVerification from './view_inspection_forms/FrameSealantWeightVerification';
import JunctionBoxSealantWeightVerification from './view_inspection_forms/JunctionBoxSealantWeight';
import JunctionBoxPottingMaterial from './view_inspection_forms/JunctionBoxPotting';
import ModuleDimensionCheck from './view_inspection_forms/ModuleDimensionCheck';
import RecordRejectedModule from './view_inspection_forms/RecordRejectedModule';
import RFIDReadability from './view_inspection_forms/RFID';
import MachineBreakdownHistory from './view_inspection_forms/MachineBreakdown';
import RootCauseAnalysis from './view_inspection_forms/RootCauseAnalysis';

const ViewInspection = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedForms, setSelectedForms] = useState([]);
  const [expandedForms, setExpandedForms] = useState({});
  const [suppliers, setSuppliers] = useState([]);
  const [selectedDate, setSelectedDate] = useState(sessionStorage.getItem('inspectionDate') || '');
  const [selectedSupplier, setSelectedSupplier] = useState(sessionStorage.getItem('inspectionSupplier') || '');
  const [selectedShift, setSelectedShift] = useState(sessionStorage.getItem('inspectionShift') || '');
  const [shiftOptions, setShiftOptions] = useState([]);
  const [showToast, setShowToast] = useState(false);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  // Fetch supplier names and shift options using POST
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const selectedProject = localStorage.getItem('selectedProject');
        const response = await axios.post(`${baseURL}get_supplier_names`, {
          projectId: selectedProject,
        });
        setSuppliers(response.data);
        const supplier = response.data.find(s => s.name === selectedSupplier) || response.data[0];
        if (supplier) {
          setShiftOptions(supplier.shift === 'MorningAfternoonNight' 
            ? ['Morning', 'Afternoon', 'Night'] 
            : ['Day', 'Night']);
        }
      } catch (err) {
        console.error('Error fetching supplier data:', err);
        setError('Failed to load supplier data.');
        setShowToast(true);
      }
    };
    fetchSuppliers();
  }, []);

  // Update shift options when supplier changes
  useEffect(() => {
    const supplier = suppliers.find(s => s.name === selectedSupplier);
    if (supplier) {
      setShiftOptions(supplier.shift === 'MorningAfternoonNight' 
        ? ['Morning', 'Afternoon', 'Night'] 
        : ['Day', 'Night']);
      setSelectedShift('');
    }
  }, [selectedSupplier, suppliers]);

  // Fetch inspection data
  useEffect(() => {
    const fetchInspectionData = async () => {
      const date = sessionStorage.getItem('inspectionDate');
      const shift = sessionStorage.getItem('inspectionShift');
      const supplier = sessionStorage.getItem('inspectionSupplier');
      const projectId = localStorage.getItem('selectedProject');

      if (!date || !shift || !supplier || !projectId) {
        setError('Missing required inspection parameters.');
        setShowToast(true);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.post(`${baseURL}get_inspection`, {
          inspectionDate: date,
          inspectionShift: shift,
          inspectionSupplier: supplier,
          projectId,
        });
        sessionStorage.setItem('inspectionData', JSON.stringify(response.data[0] || {}));
        setLoading(false);
      } catch (err) {
        console.error('Error fetching inspection data:', err);
        setError('Failed to load inspection data. Please try again.');
        setShowToast(true);
        setLoading(false);
      }
    };

    fetchInspectionData();
  }, []);

  // Auto-dismiss toast after 5 seconds
  useEffect(() => {
    if (showToast) {
      const timer = setTimeout(() => setShowToast(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [showToast]);

  const toggleFormSelection = (formKey) => {
    setSelectedForms((prev) =>
      prev.includes(formKey) ? prev.filter((key) => key !== formKey) : [...prev, formKey]
    );
  };

  const toggleFormExpansion = (formKey) => {
    setExpandedForms((prev) => ({
      ...prev,
      [formKey]: !prev[formKey],
    }));
  };

  const handleSearch = () => {
    if (selectedDate && selectedSupplier && selectedShift) {
      sessionStorage.setItem('inspectionDate', selectedDate);
      sessionStorage.setItem('inspectionSupplier', selectedSupplier);
      sessionStorage.setItem('inspectionShift', selectedShift);
      window.location.reload();
    } else {
      setError('Please select date, supplier, and shift.');
      setShowToast(true);
    }
  };

  const GenericFormView = () => {
    const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
    const formKey = 'stringerMainFormData';
    const data = inspectionData[formKey];
    if (!data) return <p className="text-gray-500 text-center">No data available</p>;
    return (
      <pre className="bg-gray-50 p-4 rounded-lg text-sm overflow-auto max-h-96 shadow-inner">
        {JSON.stringify(data, null, 2)}
      </pre>
    );
  };

  const formComponents = {
    PreLaminationFormData: PreLaminationView,
    PostLaminationFormData: PostLaminationView,
    BillOfMaterials: BillOfMaterial,
    DailyVolumeFormData: DailyVolumeF4,
    StringerFormData: StringerMain,
    PeelStrengthFormData: GenericFormView,
    CellToRibbonPeelStrengthFormData: GenericFormView,
    LaminationMachineFormData: LaminationMachine,
    CalibrationVerificationFormData: CalibrationVerification,
    FlashTestWitnessFormData: FlashTestWitness,
    PrimaryModuleCalibrationFormData: PrimaryModuleCalibration,
    FrameSealantWeightFormData: FrameSealantWeightVerification,
    JunctionBoxSealantFormData: JunctionBoxSealantWeightVerification,
    JunctionBoxPottingFormData: JunctionBoxPottingMaterial,
    ModuleDimensionCheckFormData: ModuleDimensionCheck,
    RecordRejectedModuleFormData: RecordRejectedModule,
    RFIDReadabilityFormData: RFIDReadability,
    MachineBreakdownFormData: MachineBreakdownHistory,
    RootCauseAnalysis: RootCauseAnalysis,
  };

  const formNames = Object.keys(formComponents);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-gray-100 to-gray-200">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-600"></div>
      </div>
    );
  }

  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-100 to-gray-200 py-4 px-4 sm:px-6 lg:px-8">
      {/* Toast Notification */}
      {showToast && (
        <div className="fixed top-4 right-4 z-50 animate-slide-in">
          <div className="bg-red-500 text-white px-4 py-3 rounded-lg shadow-lg flex items-center">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>{error}</span>
            <button onClick={() => setShowToast(false)} className="ml-4 text-white hover:text-gray-200">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      )}
      
      <div className="max-w-7xl mx-auto">
        {/* Header and Search */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 text-center mb-4">INSPECTION DASHBOARD</h1>
          {/* Search Section */}
          <div className="bg-white rounded-xl shadow-2xl p-6">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Search Inspection Data</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Date</label>
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="w-full p-3 border border-gray-200 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  aria-label="Inspection Date"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Supplier</label>
                <select
                  value={selectedSupplier}
                  onChange={(e) => setSelectedSupplier(e.target.value)}
                  className="w-full p-3 border border-gray-200 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  aria-label="Supplier"
                >
                  <option value="">Select Supplier</option>
                  {suppliers.map((supplier) => (
                    <option key={supplier.name} value={supplier.name}>
                      {supplier.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Shift</label>
                <select
                  value={selectedShift}
                  onChange={(e) => setSelectedShift(e.target.value)}
                  className="w-full p-3 border border-gray-200 rounded-lg shadow-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                  aria-label="Shift"
                >
                  <option value="">Select Shift</option>
                  {shiftOptions.map((shift) => (
                    <option key={shift} value={shift}>
                      {shift}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex items-end">
                <button
                  onClick={handleSearch}
                  className="w-full bg-gray-600 text-white p-3 rounded-lg shadow-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition duration-200 relative overflow-hidden ripple"
                >
                  <span className="relative z-10">Search</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Main Layout: Left Sidebar and Right Content */}
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Left Sidebar: Form List */}
          <div className="lg:w-1/4 bg-white rounded-xl shadow-2xl p-6 h-full overflow-y-auto">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Available Forms</h2>
            <ul className="space-y-2">
              {formNames.map((formKey) => (
                <li key={formKey}>
                  <button
                    onClick={() => toggleFormSelection(formKey)}
                    className={`w-full text-left p-3 rounded-lg transition duration-200 ${
                      selectedForms.includes(formKey)
                        ? 'bg-indigo-100 text-gray-700 font-medium'
                        : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
                    }`}
                    aria-label={`Toggle ${formKey.replace(/([A-Z])/g, ' $1').trim()}`}
                  >
                    {formKey.replace(/([A-Z])/g, ' $1').trim()}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Content: Selected Forms */}
          <div className="lg:w-3/4 bg-white rounded-xl shadow-2xl p-6 min-h-[calc(100vh-300px)]">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Selected Forms</h2>
            {selectedForms.length === 0 ? (
              <p className="text-gray-500 text-center py-8">Select forms from the left to view their data.</p>
            ) : (
              <div className="space-y-4">
                {selectedForms.map((formKey) => {
                  const FormComponent = formComponents[formKey];
                  return (
                    <div key={formKey} className="border border-gray-200 rounded-lg overflow-hidden">
                      <button
                        onClick={() => toggleFormExpansion(formKey)}
                        className="w-full flex justify-between items-center p-4 bg-gradient-to-r from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 focus:outline-none transition duration-200"
                        aria-expanded={expandedForms[formKey]}
                        aria-controls={`form-${formKey}`}
                      >
                        <span className="text-lg font-semibold text-gray-800">
                          {formKey.replace(/([A-Z])/g, ' $1').trim()}
                        </span>
                        <span className="text-gray-600 text-xl transform transition-transform duration-200">
                          {expandedForms[formKey] ? '▲' : '▼'}
                        </span>
                      </button>
                      {expandedForms[formKey] && (
                        <div id={`form-${formKey}`} className="p-6 bg-gray-50 animate-fade-in">
                          <FormComponent />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Custom CSS for Animations */}
      <style jsx>{`
        .ripple {
          position: relative;
          overflow: hidden;
        }
        .ripple::after {
          content: '';
          position: absolute;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          transform: scale(0);
          animation: ripple 0.6s linear;
          top: 50%;
          left: 50%;
          width: 100px;
          height: 100px;
          margin: -50px 0 0 -50px;
        }
        @keyframes ripple {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        .animate-slide-in {
          animation: slideIn 0.3s ease-out;
        }
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in {
          animation: fadeIn 0.3s ease-out;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default ViewInspection;